import { render, staticRenderFns } from "./newbooking_component.vue?vue&type=template&id=7247dd9a&scoped=true&"
import script from "../assets/js/newbooking.js?vue&type=script&lang=js&"
export * from "../assets/js/newbooking.js?vue&type=script&lang=js&"
import style0 from "./newbooking_component.vue?vue&type=style&index=0&id=7247dd9a&scoped=true&lang=css&"
import style1 from "./newbooking_component.vue?vue&type=style&index=1&id=7247dd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7247dd9a",
  null
  
)

export default component.exports